// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"0749e216","174":"3cc77ec5","453":"0a7178e6"}[chunkId] + ".chunk.js";
};